import { Component, OnInit, OnDestroy, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { WindowManagerService } from '../services/window-manager.service';

@Component({
  selector: 'app-minimized-tray',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (minimizedWindows().length > 0) {
      <div class="fixed bottom-0 left-0 right-0 bg-gray-800 dark:bg-gray-900 border-t border-gray-700 shadow-lg z-[9999] px-4 py-2">
        <div class="flex items-center gap-2 overflow-x-auto">
          @for (window of minimizedWindows(); track window.id) {
            <button
              (click)="restoreWindow(window)"
              class="flex items-center gap-2 px-4 py-2 bg-gray-700 dark:bg-gray-800 hover:bg-gray-600 dark:hover:bg-gray-700 rounded-lg text-sm text-gray-200 dark:text-gray-300 whitespace-nowrap transition-colors min-w-[200px] shadow-md"
            >
              <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span class="flex-1 text-left truncate">{{ window.title }}</span>
              <span class="text-xs text-gray-400 dark:text-gray-500">Draft</span>
              <button
                (click)="closeWindow(window.id); $event.stopPropagation()"
                class="w-5 h-5 rounded hover:bg-red-600 dark:hover:bg-red-700 flex items-center justify-center transition-colors ml-1"
                title="Close"
              >
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </button>
          }
        </div>
      </div>
    }
  `,
})
export class MinimizedTrayComponent implements OnInit, OnDestroy {
  private readonly windowManager = inject(WindowManagerService);
  private readonly router = inject(Router);
  private subscription?: Subscription;

  minimizedWindows = signal<any[]>([]);

  ngOnInit() {
    this.subscription = this.windowManager.windows$.subscribe(windows => {
      this.minimizedWindows.set(windows.filter(w => w.state === 'minimized'));
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  restoreWindow(window: any) {
    this.windowManager.restoreWindow(window.id);
    this.windowManager.bringToFront(window.id);
    
    // Navigate to the form route to restore it
    if (window.component === 'customer-form') {
      if (window.data?.id) {
        // Editing existing customer
        this.router.navigate(['/crm/customers', window.data.id, 'edit']);
      } else {
        // New customer - use formId from data or generate new
        const formId = window.data?.formId || `new_${Date.now()}`;
        this.router.navigate(['/crm/customers', 'new'], { 
          queryParams: { formId },
          skipLocationChange: false 
        });
      }
    }
  }

  closeWindow(windowId: string) {
    this.windowManager.closeWindow(windowId);
  }
}

